<div class="toolbar"></div>
<div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
  @if (recordFound()) {
    <div>
      <table class="mainContentGrid">
        <tr>
          <td class="topLeftColumn">
          <table matTooltip="Project Information is based on either the furnished Purchase Order or Approved EnCompass Order.
                                    This information is audited by the Credit Department" class="displayTable">
              <thead>
                <tr>
                  <td colspan="6" class="tableCell centeredCell headerCell">Project Information</td>
                </tr>
              </thead>
              <tr>
                <td class="rightAligned labelColumn"><label>PO#:</label></td>
                <td class="dataColumn"><label>{{ sabrSummary().project.purchaseOrderNumber }}</label></td>
                <td class="rightAligned labelColumn"><label>Customer:</label></td>
                <td class="dataColumn"><label>{{ sabrSummary().project.customerName }}</label></td>
                <td class="rightAligned labelColumn"><label>Current Enc Order:</label></td>
                <td class="dataColumn">
                  <a
                    routerLink="/orders/{{sabrSummary().project.currentEncompassOrder.entityId}}/{{sabrSummary().project.currentEncompassOrder.entityRevision}}"
                    target="_blank">
                    {{ sabrSummary().project.currentEncompassOrder.entityId }}
                    ;{{ sabrSummary().project.currentEncompassOrder.entityRevision }}
                  </a>
                </td>
              </tr>
              <tr>
                <td class="rightAligned labelColumn"><label>Project:</label></td>
                <td class="dataColumn"><label>{{ sabrSummary().project.project }}</label></td>
                <td class="rightAligned labelColumn"><label>Rep Office:</label></td>
                <td class="dataColumn"><label>{{ sabrSummary().project.salesRepName }}</label></td>
                <td class="rightAligned labelColumn"><label>Current Approved Qty:</label></td>
                @if (sabrSummary().project.salesChannelCode === 'C') {
                  <td
                    matTooltip="The unit quantity stated on the customer's purchase order"
                    class="dataColumn">
                    <label>{{ sabrSummary().project.quantity }}</label>
                  </td>
                }
                @if (sabrSummary().project.salesChannelCode === 'B') {
                  <td
                    matTooltip="The unit quantity provided through the approved EnCompass order"
                    class="dataColumn">
                    <label>{{ sabrSummary().project.quantity }}</label>
                  </td>
                }
                @if (sabrSummary().project.salesChannelCode != 'B' && sabrSummary().project.salesChannelCode != 'C') {
                  <td
                    class="dataColumn">
                    <label>{{ sabrSummary().project.quantity }}</label>
                  </td>
                }
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="rightAligned labelColumn"><label>Current Approved Amt:</label></td>
                @if (sabrSummary().project.salesChannelCode === 'C') {
                  <td
                    matTooltip="The amount stated on the customer's purchase order" class="dataColumn">
                    <label>{{ sabrSummary().project.amount | currency:'USD' }}</label></td>
                  }
                  @if (sabrSummary().project.salesChannelCode === 'B') {
                    <td
                      matTooltip="The amount provided through the approved EnCompass order"
                      class="dataColumn"><label>{{ sabrSummary().project.amount | currency:'USD' }}</label></td>
                    }
                    @if (sabrSummary().project.salesChannelCode != 'B' && sabrSummary().project.salesChannelCode != 'C') {
                      <td
                        class="dataColumn"><label>{{ sabrSummary().project.amount | currency:'USD' }}</label></td>
                      }
                    </tr>
                  </table>
                </td>
                <td class="topMiddleColumn">
                  <table class="amountsTable">
                    <thead>
                      <tr>
                        <td colspan="3" class="tableCell centeredCell headerCell">Project Amounts</td>
                      </tr>
                    </thead>
                    <tr>
                      <td class="tableCell centeredCell headerCell">Status</td>
                      <td class="tableCell centeredCell headerCell">Quantity</td>
                      <td class="tableCell centeredCell headerCell">Amount</td>
                    </tr>
            <tr matTooltip="Qty and Amount not released to IEC for production.
                        Current Approved Qty and Amount - Released Qty and Amount">
                      <td class="tableCell centeredCell">Unreleased</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().unreleasedQuantity }}</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().unreleasedAmount | currency:'USD' }}</td>
                    </tr>
                    <tr matTooltip="Releases that have been generated but have not shipped yet">
                      <td class="tableCell centeredCell">Released-In Process</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().releasedInProcessQuantity }}</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().releasedInProcessAmount | currency:'USD' }}</td>
                    </tr>
                    <tr matTooltip="Releases that have been generated, shipped, and invoiced">
                      <td class="tableCell centeredCell">Released-Shipped</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().releasedShippedQuantity }}</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().releasedShippedAmount | currency:'USD' }}</td>
                    </tr>
                    <tr>
                      <td class="tableCell centeredCell">Total</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().project.quantity }}</td>
                      <td class="tableCell centeredCell">{{ sabrSummary().project.amount | currency:'USD' }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="leftColumn">
                  <table sortable-table (sorted)="onSortedReleases($event)" class="resultsTable">
                    <thead>
                      <tr>
                        <td colspan="11" class="tableCell centeredCell headerCell">Release Information</td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th sortable-column="release.erpOrder" class="tableCell centeredCell headerCell">ERP Order
                        </th>
                        <th sortable-column="release.encompassReleaseNumber"
                          class="tableCell centeredCell headerCell">EnC Release
                        </th>
                        <th class="tableCell centeredCell headerCell">Lead Time</th>
                        <th class="tableCell centeredCell headerCell">ERP Status</th>
                        <th sortable-column="release.scheduleDate" class="tableCell centeredCell headerCell">Sch
                          Dt
                        </th>
                        <th class="tableCell centeredCell headerCell">Rel Qty</th>
                        <th class="tableCell centeredCell headerCell">Rel Amt</th>
                        <th class="tableCell centeredCell headerCell">Inv Qty</th>
                        <th class="tableCell centeredCell headerCell">Inv Amt</th>
                        <th class="tableCell centeredCell headerCell">Rem Qty</th>
                        <th class="tableCell centeredCell headerCell">Rem Amt</th>
                      </tr>
                      <tr class="lightGray">
                        <td class="tableCell centeredCell">Unreleased</td>
                        <td class="tableCell centeredCell">NA</td>
                        <td class="tableCell centeredCell">NA</td>
                        <td class="tableCell centeredCell">NA</td>
                        <td class="tableCell centeredCell">NA</td>
                        <td class="tableCell centeredCell">{{ sabrSummary().unreleasedQuantity }}</td>
                        <td class="tableCell centeredCell">{{ sabrSummary().unreleasedAmount | currency:'USD' }}</td>
                        <td class="tableCell centeredCell">{{ 0 }}</td>
                        <td class="tableCell centeredCell">{{ 0.00 | currency:'USD' }}</td>
                        <td class="tableCell centeredCell">{{ 0 }}</td>
                        <td class="tableCell centeredCell">{{ 0.00 | currency:'USD' }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      @for (release of sabrSummary().releases; track release) {
                        <tr>
                          <td class="tableCell centeredCell" matTooltip="Manufacturer’s internal tracking number"
                            [matTooltipPosition]="positionOptions[1]">{{ release.erpOrder }}
                          </td>
                          <td class="tableCell centeredCell" matTooltip="EnCompass release number"
                            [matTooltipPosition]="positionOptions[1]">
                            <a routerLink="/orders/{{release.encompassReleaseNumber}}/{{release.encompassReleaseRevision}}"
                              target="_blank">
                              {{ release.encompassReleaseNumber }}
                            </a>
                          </td>
                          @if (release.leadTime === 'REG' || release.leadTime === 'MHR') {
                            <td
                              matTooltip="Standard Lead Time" class="tableCell centeredCell">{{ release.leadTime }}
                            </td>
                          }
                          @if (release.leadTime === 'SST' || release.leadTime === 'SS2' || release.leadTime === 'PTO') {
                            <td
                              matTooltip="Expedited Lead Time"
                              class="tableCell centeredCell">{{ release.leadTime }}
                            </td>
                          }
                          @if (release.leadTime === 'PTS' || release.leadTime === 'WAR' || release.leadTime === 'SLC') {
                            <td
                              matTooltip="Replacement Parts Lead Time"
                              class="tableCell centeredCell">{{ release.leadTime }}
                            </td>
                          }
                          @if (release.leadTime != 'REG' && release.leadTime != 'MHR' &&
                            release.leadTime != 'SST' && release.leadTime != 'SS2' && release.leadTime !='PTO' &&
                            release.leadTime != 'PTS' && release.leadTime != 'WAR' && release.leadTime != 'SLC') {
                            <td
                              class="tableCell centeredCell">{{ release.leadTime }}
                            </td>
                          }
                          @if (release.erpStatus === 'Approved' || release.erpStatus === 'InProcess' || release.erpStatus === 'EngWorkLst') {
                            <td
                              matTooltip="Release is going through manufacturer's internal review and engineering"
                              class="tableCell centeredCell">{{ release.erpStatus }}
                            </td>
                          }
                          @if (release.erpStatus === 'Entered') {
                            <td
                              matTooltip="Release has been entered in the manufacturer's ERP system and is scheduled"
                              class="tableCell centeredCell">{{ release.erpStatus }}
                            </td>
                          }
                          @if (release.erpStatus === 'PartialShp') {
                            <td
                              matTooltip="Release has not completely shipped"
                              class="tableCell centeredCell">{{ release.erpStatus }}
                            </td>
                          }
                          @if (release.erpStatus === 'Shipped') {
                            <td
                              matTooltip="Release has shipped in its entirety"
                              class="tableCell centeredCell">{{ release.erpStatus }}
                            </td>
                          }
                          @if (release.erpStatus != 'Approved' && release.erpStatus !='InProcess' && release.erpStatus !='EngWorkLst' &&
                            release.erpStatus != 'Entered' && release.erpStatus != 'PartialShp' && release.erpStatus != 'Shipped') {
                            <td
                              class="tableCell centeredCell">{{ release.erpStatus }}
                            </td>
                          }
                          <td class="tableCell centeredCell">{{ release.scheduleDate | date: 'MM/dd/yyyy' }}</td>
                          <td matTooltip="Final release amounts, may differ slightly with EnCompass"
                            class="tableCell centeredCell">{{ release.quantity }}
                          </td>
                          <td matTooltip="Final release amounts, may differ slightly with EnCompass"
                            class="tableCell centeredCell">{{ release.amount | currency:'USD' }}
                          </td>
                          <td matTooltip="Unit Quantity and Amount shipped to date"
                            class="tableCell centeredCell">{{ release.invoiceQuantity }}
                          </td>
                          <td matTooltip="Unit Quantity and Amount shipped to date"
                            class="tableCell centeredCell">{{ release.invoiceAmount | currency:'USD' }}
                          </td>
                          <td matTooltip="Unit Quantity and Amount remaining to be shipped"
                            class="tableCell centeredCell">{{ release.remainingQuantity }}
                          </td>
                          <td matTooltip="Unit Quantity and Amount remaining to be shipped"
                            class="tableCell centeredCell">{{ release.remainingAmount | currency:'USD' }}
                          </td>
                        </tr>
                      }
                    </tbody>
                    @if (sabrSummary().releases.length > 0) {
                      <tfoot>
                        <td class="tableCell centeredCell">Total</td>
                        @if (sabrSummary().releases.length == 1) {
                          <td
                            class="tableCell centeredCell">{{ sabrSummary().releases.length }} Release
                          </td>
                        }
                        @if (sabrSummary().releases.length > 1) {
                          <td
                            class="tableCell centeredCell">{{ sabrSummary().releases.length }} Releases
                          </td>
                        }
                        <td class="tableCell centeredCell"></td>
                        <td class="tableCell centeredCell"></td>
                        <td class="tableCell centeredCell"></td>
                        <td class="tableCell centeredCell">{{ getTotalReleasedQuantity(sabrSummary().releases) }}</td>
                        <td class="tableCell centeredCell">{{ getTotalReleasedAmount(sabrSummary().releases) | currency:'USD' }}</td>
                        <td class="tableCell centeredCell">{{ getTotalReleaseInvoiceQuantity(sabrSummary().releases) }}</td>
                        <td
                          class="tableCell centeredCell">{{ getTotalReleaseInvoiceAmount(sabrSummary().releases) | currency:'USD' }}
                        </td>
                        <td class="tableCell centeredCell">{{ getTotalRemainingQuantity(sabrSummary().releases) }}</td>
                        <td class="tableCell centeredCell">{{ getTotalRemainingAmount(sabrSummary().releases) | currency:'USD' }}</td>
                      </tfoot>
                    }
                  </table>
                </td>
                <td colspan="2" class="rightColumn">
                  <table sortable-table (sorted)="onSortedInvoices($event)" class="resultsTable">
                    <thead>
                      <tr>
                        <td colspan="5" class="tableCell centeredCell headerCell">Invoices</td>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th sortable-column="invoice.shipDate" class="tableCell centeredCell headerCell">Ship Date
                        </th>
                        <th sortable-column="invoice.orderNumber" class="tableCell centeredCell headerCell">ERP
                          Order
                        </th>
                        <th sortable-column="invoice.invoiceNumber" class="tableCell centeredCell headerCell">
                          Invoice #
                        </th>
                        <th class="tableCell centeredCell headerCell">Quantity</th>
                        <th class="tableCell centeredCell headerCell">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (invoice of sabrSummary().invoices; track invoice) {
                        <tr>
                          <td matTooltip="Date of shipment"
                            class="tableCell centeredCell">{{ invoice.shipDate | date: 'MM/dd/yyyy' }}
                          </td>
                          <td matTooltip="Manufacturer's internal tracking number"
                            class="tableCell centeredCell">{{ invoice.orderNumber }}
                          </td>
                          <td matTooltip="Hyperlink will provide a download of invoice"
                            class="tableCell centeredCell docLink"
                            (click)="getInvoiceDocument(invoice.invoiceNumber)">
                            {{ invoice.invoiceNumber }}
                          </td>
                          <td matTooltip="The quantity and amount shipped on the particular invoice"
                            class="tableCell centeredCell">{{ invoice.quantity }}
                          </td>
                          <td matTooltip="The quantity and amount shipped on the particular invoice"
                            class="tableCell centeredCell">{{ invoice.amount | currency:'USD' }}
                          </td>
                        </tr>
                      }
                    </tbody>
                    <tfoot>
                      @if (sabrSummary().invoices.length > 0) {
                        <tr>
                          <td class="tableCell centeredCell">Total</td>
                          <td class="tableCell centeredCell"></td>
                          @if (sabrSummary().invoices.length == 1) {
                            <td
                              class="tableCell centeredCell">{{ sabrSummary().invoices.length }} Invoice
                            </td>
                          }
                          @if (sabrSummary().invoices.length > 1) {
                            <td
                              class="tableCell centeredCell">{{ sabrSummary().invoices.length }} Invoices
                            </td>
                          }
                          <td class="tableCell centeredCell">{{ getTotalInvoiceQuantity(sabrSummary().invoices) }}</td>
                          <td class="tableCell centeredCell">{{ getTotalInvoiceAmount(sabrSummary().invoices) | currency:'USD' }}</td>
                        </tr>
                      }
                    </tfoot>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        }
      </div>
